import { Grid } from '@mui/material';

import { disabledFutureDate } from '../../../../helpers';
import { FormDateField, FormTextField } from '../../components';

import type { MedicationFieldsProps } from './types';

export default function MedicationFields({
  formik,
  disabled,
  readOnly,
  saveField,
  backgroundColor,
  monthFormat,
  startDateLabel = 'Start month',
  startDatePlaceholder,
  columns = { medication: 4, dosage: 1.5, startDate: 1.5, physician: 2.5, reason: 2.5 },
}: MedicationFieldsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={columns.medication}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="Medication"
          name="medication_name"
          onBlur={saveField}
          placeholder="Enter medication name"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={columns.dosage}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="Dosage"
          name="dosage"
          onBlur={saveField}
          placeholder="Dosage"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={columns.startDate}>
        <FormDateField
          backgroundColor={backgroundColor}
          disabled={disabled}
          disabledDate={disabledFutureDate}
          formik={formik}
          format={monthFormat}
          readOnly={readOnly}
          label={startDateLabel}
          name="start_date"
          onChange={saveField}
          picker="month"
          placeholder={startDatePlaceholder ?? monthFormat}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={columns.physician}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="Prescribing physician"
          name="physician_name"
          onBlur={saveField}
          placeholder="Enter name"
          required
        />
      </Grid>
      <Grid item xs={12} md={columns.reason}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="Reason for taking"
          name="reason"
          onBlur={saveField}
          placeholder="Enter reason"
          required
        />
      </Grid>
    </Grid>
  );
}
